import { createSlice } from '@reduxjs/toolkit';
import type { PayloadAction } from '@reduxjs/toolkit';

export interface AuthState {
  userAuthenticated: boolean,
}

const initialState: AuthState = {
  userAuthenticated: true,
};

const slice = createSlice({
  name: 'auth',
  initialState,
  reducers: {
    setUserAuthenticated(
      state: AuthState,
      action: PayloadAction<{ authenticated: boolean }>
    ) {
      const { authenticated } = action.payload;

      state.userAuthenticated = authenticated;
    }
  }
});

export const { reducer } = slice;

export const { setUserAuthenticated } = slice.actions;

export default slice;
